import { Simulation } from 'src/app/core/models/simulation.model';
import { SceneService } from 'src/app/core/services/three-d/scene/scene.service';
import { BufferGeometry, Group, Line, Mesh, Object3D } from 'three';
import { Catenary3D } from '../../catenary-answer';

export default abstract class ObjectBuilder {
  protected _object: Line | Object3D | Mesh | Group | any;

  constructor() {}

  abstract build(
    riser: Catenary3D,
    simulation: Simulation,
    simulationObject: any,
    sceneService: SceneService,
  ): any;

  abstract createGeometry(riser: Catenary3D, simulationObject: any): BufferGeometry;

  abstract createMaterial(riser: Catenary3D, simulationObject: any): any;

  abstract transform(simulationObject: any): void;
}
